import React, { useEffect, useState } from 'react';

import { FilledButton } from '../components/common/Button';

import useRouting from '../hooks/useRouting';


const EngagementsPage: React.FC = () => {

    const tabs = [
        'As Talent',
        'As Project Manager',
    ]

    const { goToJobs } = useRouting();

    return (
        <div className="p-4 max-w-7xl mx-auto">
            {/* Header section */}
            <div className="mt-4 flex flex-col md:flex-row justify-between md:items-center">
                <h3 className="font-bold">Applications & Invitations</h3>
            </div>


            {/* No data available  */}
            <div className="mt-4 flex flex-col items-center space-y-4">
                <img
                    src="https://storage.googleapis.com/public-platform-assets/images/no_data.svg"
                    alt="No Data"
                    className="w-2/3"
                />
                <p className="body1">Open Engagements Overview Coming Soon</p>

                <p className="body3 text-neutral-700">Here you will manage your applications and invitations</p>
                <FilledButton onClick={goToJobs}>
                    Find Jobs
                </FilledButton>
            </div>
        </div >

    );
};

export default EngagementsPage;
